/**
 * @fileoverview Composes state, effects, and handlers for the Chat page.
 * @module pages/chat/useChat
 */
import useChatContext from "./useChatContext.js";
import useChatSocket from "./useChatSocket.js";
import useChatEffects from "./useChatEffects.js";
import useChatHandlers from "./useChatHandlers.js";
import { buildChatViewModel } from "./buildChatViewModel.js";

/** View-model hook for the Chat page. */
const useChat = () => {
  const ctx = useChatContext();
  const socket = useChatSocket(ctx);
  useChatEffects(ctx, socket);
  const handlers = useChatHandlers(ctx);
  return buildChatViewModel(ctx, handlers);
};

export default useChat;
